import { defineComponent as x, onBeforeUnmount as z, openBlock as s, createElementBlock as a, unref as e, normalizeClass as i, createElementVNode as M, createCommentVNode as A, Fragment as d, renderList as b, toDisplayString as H, createVNode as O } from "vue";
import { basicDateTableEmits as j, basicDateTableProps as q } from "./index940.js";
import { useBasicDateTable as G, useBasicDateTableDOM as I } from "./index941.js";
import J from "./index938.js";
const Q = ["aria-label"], X = ["aria-label"], Y = ["aria-current", "aria-selected", "tabindex", "aria-disabled"];
var re = /* @__PURE__ */ x({
  __name: "basic-date-table",
  props: q,
  emits: j,
  setup(y, { expose: E, emit: w }) {
    const m = y, B = w, {
      WEEKS: N,
      rows: F,
      tbodyRef: R,
      currentCellRef: T,
      focus: W,
      isCurrent: h,
      isWeekActive: P,
      isSelectedCell: p,
      handlePickDate: c,
      handleMouseUp: f,
      handleMouseDown: k,
      handleMouseMove: C,
      handleFocus: D
    } = G(m, B), { tableLabel: S, tableKls: U, getCellClasses: V, getRowKls: K, weekHeaderClass: L, t: g } = I(m, {
      isCurrent: h,
      isWeekActive: P
    });
    let v = !1;
    return z(() => {
      v = !0;
    }), E({
      /**
       * @description focus on current cell
       */
      focus: W
    }), (o, r) => (s(), a("table", {
      "aria-label": e(S),
      class: i(e(U)),
      cellspacing: "0",
      cellpadding: "0",
      role: "grid",
      onClick: r[1] || (r[1] = //@ts-ignore
      (...t) => e(c) && e(c)(...t)),
      onMousemove: r[2] || (r[2] = //@ts-ignore
      (...t) => e(C) && e(C)(...t)),
      onMousedown: r[3] || (r[3] = //@ts-ignore
      (...t) => e(k) && e(k)(...t)),
      onMouseup: r[4] || (r[4] = //@ts-ignore
      (...t) => e(f) && e(f)(...t))
    }, [
      M(
        "tbody",
        {
          ref_key: "tbodyRef",
          ref: R
        },
        [
          M("tr", null, [
            o.showWeekNumber ? (s(), a(
              "th",
              {
                key: 0,
                scope: "col",
                class: i(e(L))
              },
              null,
              2
              /* CLASS */
            )) : A("v-if", !0),
            (s(!0), a(
              d,
              null,
              b(e(N), (t, n) => (s(), a("th", {
                key: n,
                "aria-label": e(g)("el.datepicker.weeksFull." + t),
                scope: "col"
              }, H(e(g)("el.datepicker.weeks." + t)), 9, X))),
              128
              /* KEYED_FRAGMENT */
            ))
          ]),
          (s(!0), a(
            d,
            null,
            b(e(F), (t, n) => (s(), a(
              "tr",
              {
                key: n,
                class: i(e(K)(o.showWeekNumber ? t[2] : t[1]))
              },
              [
                (s(!0), a(
                  d,
                  null,
                  b(t, (l, $) => (s(), a("td", {
                    key: `${n}.${$}`,
                    ref_for: !0,
                    ref: (u) => !e(v) && e(p)(l) && (T.value = u),
                    class: i(e(V)(l)),
                    "aria-current": l.isCurrent ? "date" : void 0,
                    "aria-selected": l.isCurrent,
                    tabindex: o.disabled ? void 0 : e(p)(l) ? 0 : -1,
                    "aria-disabled": o.disabled,
                    onFocus: r[0] || (r[0] = //@ts-ignore
                    (...u) => e(D) && e(D)(...u))
                  }, [
                    O(e(J), { cell: l }, null, 8, ["cell"])
                  ], 42, Y))),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              2
              /* CLASS */
            ))),
            128
            /* KEYED_FRAGMENT */
          ))
        ],
        512
        /* NEED_PATCH */
      )
    ], 42, Q));
  }
});
export {
  re as default
};
